export default __webpack_public_path__ + "static/media/risk-identification-1.b5ea4662.svg";